import { useState } from "react";

import { useSnackbar } from "notistack";

import { trpc } from "@/common/helpers/trpc";
import { useTranslate } from "@/common/hooks/useTranslate";
import { RouterInputs } from "@/common/types/trpc";

type SendAutomatedEmailTestInput = RouterInputs["sendAutomatedEmailTest"];

export const useSendAutomatedEmailTest = () => {
  const { t } = useTranslate();
  const { enqueueSnackbar } = useSnackbar();
  const { mutateAsync } = trpc.sendAutomatedEmailTest.useMutation();
  const [isSending, setIsSending] = useState(false);

  const sendTest = async (input: SendAutomatedEmailTestInput): Promise<boolean> => {
    setIsSending(true);
    try {
      const { error } = await mutateAsync(input);

      if (error) {
        enqueueSnackbar(getErrorMessage(error.code, t), { vibe: "danger" });
        return false;
      }

      enqueueSnackbar(t("dashboard", "email.testEmailDelivered"), { vibe: "positive" });
      return true;
    } finally {
      setIsSending(false);
    }
  };

  return { sendTest, isSending };
};

const getErrorMessage = (code: string | undefined, t: ReturnType<typeof useTranslate>["t"]): string => {
  switch (code) {
    case "recipients_not_organization_members":
      return t("dashboard", "error.sendEmail.testEmailRecipientNotMember");
    case "recipient_email_not_verified":
      return t("dashboard", "error.sendEmail.testEmailRecipientNotVerified");
    default:
      return t("dashboard", "error.sendEmail.sendingFailed");
  }
};
